<script>
import axios from '@/utils/axios';

export default {
  name: 'HrmAssetReturnModal',
  inject: ['setLoading'],
  props: {
    assignment: { type: Object, default: null },
  },
  emits: ['returned'],
  data() {
    return {
      errors: {},
      form: {
        condition_at_return: 'good',
        return_notes: '',
      },
      conditions: [
        { id: 'excellent', name: 'Excellent' },
        { id: 'good', name: 'Good' },
        { id: 'fair', name: 'Fair' },
        { id: 'poor', name: 'Poor' },
        { id: 'damaged', name: 'Damaged' },
      ],
    };
  },

  watch: {
    assignment: {
      immediate: true,
      handler() {
        this.errors = {};
        this.form = { condition_at_return: 'good', return_notes: '' };
      },
    },
  },

  methods: {
    async submit() {
      if (!this.assignment) return;
      this.errors = {};
      this.setLoading(true);
      try {
        await axios.post(`/hrms/assets/${this.assignment.asset_id || this.assignment.asset?.id}/return`, this.form);
        this.$swalToast('Asset returned successfully.');
        this.$closeModal('hrm_asset_return_modal');
        this.$emit('returned');
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  }
};
</script>

<template>
  <div class="modal fade" id="hrm_asset_return_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Return Asset</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="d-flex align-items-center p-2 mb-3 rounded bg-light" v-if="assignment">
            <div>
              <strong class="text-dark d-block">{{ assignment.asset?.name }}</strong>
              <small class="text-muted">Assigned to {{ assignment.employee?.full_name || assignment.employee?.code }}</small>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Condition at Return <span class="text-danger">*</span></label>
            <vue-select v-model="form.condition_at_return" :options="conditions" label="name" :reduce="c => c.id"
              placeholder="Select Condition"></vue-select>
            <span class="text-danger" style="font-size:12px;" v-if="errors.condition_at_return">{{ errors.condition_at_return[0] }}</span>
          </div>

          <div class="mb-3">
            <label class="form-label">Return Notes</label>
            <textarea class="form-control" rows="3" v-model="form.return_notes" placeholder="Optional notes"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submit">Mark as Returned</button>
        </div>
      </div>
    </div>
  </div>
</template>